// extracted by mini-css-extract-plugin
module.exports = {"logos":"styles-module--logos---21wn","logo":"styles-module--logo--titey","inView":"styles-module--inView--2HRF1","link":"styles-module--link--1jq5g"};